import React, {FunctionComponent} from 'react';
import {Box, Button, Container, Paper, Typography} from '@material-ui/core';
import {Form, Formik} from 'formik';
import {useTranslation} from 'react-i18next';
import {history} from 'index';
import * as yup from 'yup';
import {Link} from "react-router-dom";
import {useLocation} from "react-router";

import secureLoginSvg from 'assets/images/undraw_authentication_fsn5.svg';
import CodeAccessField from 'components/Form/CodeAccessField/CodeAccessField';
import LoadingWrapper from 'components/LoadingWrapper';
import {useAppDispatch} from 'store';
import {loginWithCode} from '../actions';
import TopBar from "../../../components/TopBar";


const Login: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {search}  = useLocation();
  const [verificationMessage, setVerificationMessage] = React.useState<string>('');

  const loginSchema = yup.object().shape({
    codeAccess: yup.array().of(yup.string()).min(4).max(4).required(t('validation:requis')),
  });


  const handleLogin = async (codeAccess: string) => {
    
    setVerificationMessage('Vérification de votre code, un instant svp...');
    const result = await dispatch(loginWithCode({ codeAccess }));
    if (loginWithCode.fulfilled.match(result)) {
      history.push(`/${result.payload.campagne}/secure?token=${result.payload.token}`);

    }
    setVerificationMessage('');
  }
  let codeAccess = ['','','',''];
  
  const parameters = new URLSearchParams(search);
  const code = parameters.get('code');
  if (code){
    codeAccess = code.split('-').map((c) => c.padStart(4, '0'));
  }

  return (
    <Container style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
      <TopBar>
        <Button component={Link} to="/admin/login" style={{ color: 'white' }}>Administration</Button>
      </TopBar>
      <Paper>
        <Box my={5} p={5} textAlign="center">
          <img src={secureLoginSvg} style={{ width: '30%' }} alt="" />
          <Typography variant="h4">Votez.com</Typography>
          <Typography variant="h5" gutterBottom>
            {t('campagne:loginHeaderMessage')}
          </Typography>

          <Formik
            initialValues={{ codeAccess}}
            validationSchema={loginSchema}
            onSubmit={(values) => handleLogin(values.codeAccess.join(''))}
          >
            {() => (
              <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <CodeAccessField name='codeAccess' />
                {verificationMessage && <Typography variant="h6" >{verificationMessage}</Typography>}
                <LoadingWrapper actionName={loginWithCode.typePrefix} >


                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                  >
                    {t('campagne:loginButton')}
                  </Button>
                </LoadingWrapper>
              </Form>
            )}
          </Formik>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;
